export * from './extended-nato.component';
